import { Clickable, LoadingBalls } from '@moda/om';
import React, { useCallback, useState } from 'react';
import { ProductDetailsFragment, SizeInventoryFragment } from '../../../../generated/types';
import { tc } from '../../../../lib/trackingContext';
import { useCreateApplePayQuickBuyCart } from './useCreateApplePayQuickBuyCart';
import { ApplePayQuickBuySession } from './ApplePayQuickBuySession';

import './ApplePayQuickBuy.scss';

interface Props {
  variant: ProductDetailsFragment;
  size: SizeInventoryFragment | null;
}

export const ApplePayQuickBuy: React.FC<Props> = ({ variant, size }) => {
  const [session, setSession] = useState<ApplePaySession>();
  const [clicked, setClicked] = useState(false);
  const {
    cartId,
    data: request,
    loading: cartRequestLoading
  } = useCreateApplePayQuickBuyCart(variant, size);

  const trackThirdParty = useCallback(() => {
    tc.track('Third Party Payment Method Flow Selected', {
      addToTrackingEvent: {
        payment_type: 'APPLE',
        label: 'APPLE'
      }
    });
  }, []);

  const handleClick = useCallback(() => {
    if (!clicked) {
      setClicked(true);
    }

    if (!request) return;

    setSession(new ApplePaySession(ApplePaySession.supportsVersion(2) ? 2 : 1, request));

    trackThirdParty();
  }, [clicked, request, trackThirdParty]);

  const noSizeSelectedScenario = clicked && !size;

  return (
    <>
      <ApplePayQuickBuySession session={session} cartId={cartId} request={request} />

      <Clickable className="ApplePayQuickBuy" onClick={handleClick}>
        {noSizeSelectedScenario && 'Select a size'}

        {!noSizeSelectedScenario && cartRequestLoading && <LoadingBalls />}

        {!noSizeSelectedScenario && !cartRequestLoading && (
          <div className="ApplePayQuickBuy__with-text ApplePayQuickBuy__white-with-text" />
        )}
      </Clickable>
    </>
  );
};
